module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAQBAMAAACFLmBqAAAAAXNSR0IB2cksfwAAACdQTFRFAAAA////////////////////////////////////////////////rj1KOQAAAA10Uk5TAChQYGiAEHgIQBhwSIBq6H4AAACHSURBVHicY2AAAUZl1xAjAQY4SCoNBYJwDRifE8wHikyA8DlcQ6EgpAEssDwUDqrACkAaosUSt4I0gZS0gKR2MDB0g2gHoMBUEANoJSOIjmRgYANbAVTKFgrRwxSKLBCqwMAeiqwltIBBNBTZ0NBABlUwDbU2NDSGwTQUBQQzuKIKhDCEogEALd5C3jmebWYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu-dashboard.png
// module id = 953
// module chunks = 0